import React from 'react';
import FileIcon from '../../../icons/FileIcon';
import FileIconWord from '../../../icons/FileIconWord';
import FileIconExcel from '../../../icons/FileIconExcel';
import FileIconPDF from '../../../icons/FileIconPDF';
import FileIconImage from '../../../icons/FileIconImage';
import FileIconVideo from '../../../icons/FileIconVideo';

// add as required: https://www.freeformatter.com/mime-types-list.html
const iconMap = {
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': FileIconWord,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': FileIconExcel,
  'application/pdf': FileIconPDF,
  'image/png': FileIconImage,
  'image/jpeg': FileIconImage,
  'image/gif': FileIconImage,
  'video/jpm': FileIconVideo,
  'video/jpeg': FileIconVideo,
  'video/mj2': FileIconVideo,
  'video/mp4': FileIconVideo,
  'video/x-ms-wmv': FileIconVideo,
  'video/x-ms-wm': FileIconVideo,
  'video/webm': FileIconVideo,
  'video/quicktime': FileIconVideo,
  'video/3gpp': FileIconVideo,
  'video/3gpp2': FileIconVideo,
  'video/x-f4v': FileIconVideo,
  'video/x-flv': FileIconVideo,
};

export const chooseIcon = (contentType, className) => {
  const Component = iconMap[contentType] || FileIcon;
  return (<Component className={className} />);
};
